import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=587507e6"
import script from "./DocumentsList.vue?vue&type=script&lang=js"
export * from "./DocumentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587507e6')) {
      api.createRecord('587507e6', component.options)
    } else {
      api.reload('587507e6', component.options)
    }
    module.hot.accept("./DocumentsList.vue?vue&type=template&id=587507e6", function () {
      api.rerender('587507e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documents/views/DocumentsList.vue"
export default component.exports